export enum FluxRestrictFlag {
    showSecificMessage		= 'showSecificMessage',		// 2^0  --> Flux spécifique à signaler lorsqu'il est affiché
    noDisplay				= 'noDisplay',				// 2^1  --> Ne pas afficher (du tout) dans l'interface partenaire et interdire la modification
    noRemove				= 'noRemove',				// 2^2  --> Interdire la suppression
                            
    noChangeItemIncluded	= 'noChangeItemIncluded',	// 2^3  --> Interdire la modification de l'étendue exportée
    noChangeItemExcluded	= 'noChangeItemExcluded',	// 2^4  --> Interdire la modification de l'étendue exclue
    noChangeMarque			= 'noChangeMarque',			// 2^5  --> Interdire la modification des marques inclues/exclues
    noChangeMetaProduit		= 'noChangeMetaProduit',	// 2^6  --> Interdire la modification des métas produit
    noChangeMetaFamille		= 'noChangeMetaFamille',	// 2^7  --> Interdire la modification des métas famille
    noChangeDispo			= 'noChangeDispo',			// 2^8  --> Interdire la modification des disponibilités
    noChangeMkp				= 'noChangeMkp',			// 2^9  --> Interdire la modification du type natif/mkp du flux
    noChangePtn				= 'noChangePtn',			// 2^10 --> Interdire la modification des partenaire
                            
    noChangeSeg				= 'noChangeSeg',			// 2^11 --> Interdire la modification des segments exportés
    noChangeStock			= 'noChangeStock',			// 2^12 --> Interdire la modification du stock minimum exporté
    noChangeEntrepot		= 'noChangeEntrepot',		// 2^13 --> Interdire la modification du filtrage par entrepôts
    noChangeRTB				= 'noChangeRTB',			// 2^14 --> Interdire la modification du filtrage par RTB
    noChangeStatut			= 'noChangeStatut',			// 2^15 --> Interdire la modification des groupes de statuts compacts exportés
    noChangeCodicExcluded	= 'noChangeCodicExcluded',	// 2^16 --> Interdire la modification des codics exclus
                            
    noDisplayItemIncluded	= 'noDisplayItemIncluded',	// 2^17 --> Ne pas afficher l'étendue exportée
    noDisplayItemExcluded	= 'noDisplayItemExcluded',	// 2^18 --> Ne pas afficher l'étendue exclue
    noDisplayMarque			= 'noDisplayMarque',		// 2^19 --> Ne pas afficher les marques inclues/exclues
    noDisplayMetaProduit	= 'noDisplayMetaProduit',	// 2^20 --> Ne pas afficher les métas produit
    noDisplayMetaFamille	= 'noDisplayMetaFamille',	// 2^21 --> Ne pas afficher les métas famille
    noDisplayDispo			= 'noDisplayDispo',			// 2^22 --> Ne pas afficher les disponibilités
    noDisplayMkp			= 'noDisplayMkp',			// 2^23 --> Ne pas afficher le type natif/mkp du flux
    noDisplayPtn			= 'noDisplayPtn',			// 2^24 --> Ne pas afficher les partenaire associés au flux
                            
    noDisplaySeg			= 'noDisplaySeg',			// 2^25 --> Ne pas afficher les segments exportés
    noDisplayStock			= 'noDisplayStock',			// 2^26 --> Ne pas afficher le stock minimum exporté
    noDisplayEntrepot		= 'noDisplayEntrepot',		// 2^27 --> Ne pas afficher le filtrage par entrepôts
    noDisplayRTB			= 'noDisplayRTB',			// 2^28 --> Ne pas afficher le filtrage par RTB
    noDisplayStatut			= 'noDisplayStatut',		// 2^29 --> Ne pas afficher les groupes de statuts compacts exportés
                            
    noDirectBuild			= 'noDirectBuild',			// 2^30 --> Interdire la génération manuelle
    noSave					= 'noSave',					// 2^31 --> Ne pas proposer l'enregistrement du flux et ne pas accepter de le modifier

    noDisplayCodicExcluded	= 'noDisplayCodicExcluded',	// 2^32 --> Ne pas afficher les codics exclus
    noEvaluation			= 'noEvaluation',			// 2^33 --> Ne pas autoriser l'évaluation
                            
    noDisplayExcludePb		= 'noDisplayExcludePb',		// 2^34 --> Ne pas afficher la possibilité d'exclure les produits avec prix-barrés
    noChangeExcludePb		= 'noChangeExcludePb',		// 2^35 --> Ne pas afficher la possibilité d'exclure les produits avec prix-barrés
                            
    noDirectCsvBuild		= 'noDirectCsvBuild',		// 2^36 --> Ne pas proposer la génération directe du flux en CSV
                            
    noChangeTransporter		= 'noChangeTransporter',	// 2^37 --> Interdire la modification des transporteurs exclus
    noDisplayTransporter	= 'noDisplayTransporter',	// 2^38 --> Ne pas afficher les transporteurs inclus/exclus

    noChangeDiscount        = 'noChangeDiscount',       // 2^41 --> Ne pas autoriser la modification ni l'assignation de discount par URF/M
    noDisplayDiscount		= 'noDisplayDiscount',      // 2^42 --> Ne pas afficher le discount par URF/M

    noRestrictIfCentralWeb	= 'noRestrictIfCentralWeb',	// 2^61 --> full admin

    noChangeTarifPro		= 'noChangeTarifPro',
    noDisplayTarifPro       = 'noDisplayTarifPro',

    noChangeFollowers       = 'noChangeFollowers',
    noDisplayFollowers      = 'noDisplayFollowers',

    noDisplayMercurial      = 'noDisplayMercurial',
    noChangeMercurial       = 'noChangeMercurial',
 }